import { Component, OnInit, Input, Inject, OnChanges, Output, EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ISmartMedia } from './smart-media.interface';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IDropDownList } from '../models/web-card-model';
import { ManikEntityFE } from '../manik-library/ManikEntityFE';
import { ManikEntityService } from '../manik-library/ManikEntityService';
declare const $: any;
export const MediaTypeList: IDropDownList[] = [
  { "DataText": "None", "DataValue": "N" },
  { "DataText": "Flexi", "DataValue": "F" },
  { "DataText": "Image", "DataValue": "I" },
  { "DataText": "Icon", "DataValue": "C" },
  { "DataText": "Video", "DataValue": "V" },
  { "DataText": "Youtube Video", "DataValue": "Y" },
  { "DataText": "Slider", "DataValue": "S" },
  { "DataText": "Solid Color", "DataValue": "O" },
  { "DataText": "Gradient", "DataValue": "G" },
  { "DataText": "Pattern", "DataValue": "P" }
];

export const ZIndexData: IDropDownList[] = [
  { "DataText": "Site Background (Bottom Most)", "DataValue": "0" },
  { "DataText": "Page Background (Bottom + 1) ", "DataValue": "2" },
  { "DataText": "Page Media (Bottom + 2)", "DataValue": "4" },
  { "DataText": "Section Media (Bottom + 3)", "DataValue": "6" },
  { "DataText": "Special Media (Top Most)", "DataValue": "8" },
];

@Component({
  selector: 'image-handler',
  templateUrl: './image-handler.component.html',
  styleUrls: ['./image-handler.component.scss']
})

export class ImageHandlerComponent extends ManikEntityFE implements OnInit, OnChanges {
  MediaPropertyForm: FormGroup;
  @Input() public ImageData: ISmartMedia;
  @Output() public OnSuccess = new EventEmitter();
  public ImgEdit: EditImageStyle = new EditImageStyle();
  public Settings: boolean = false;
  public EditProperties: boolean = false;
  public icon: string;
  public MediaType: IDropDownList[] = [];
  public ZIndex: IDropDownList[] = ZIndexData;
  public SliderMediaType: IDropDownList[] = [];
  public SMediaModel: SmartMediaModel = new SmartMediaModel();
  public PatternList: any;
  public UseOverlay: boolean = false;
  public Overlay: string = "N";
  SliderImages = [];
  private PortalContext: string = "";
  public ZIndexSelectedValue: string;
  constructor(private formBuilder: FormBuilder, private _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.MediaPropertyForm = this.formBuilder.group({
      Header: [''],
      SubHeader: [''],
      Description: ['']
    });

    this.PortalContext = sessionStorage.getItem("PortalIdentifier") ? sessionStorage.getItem("PortalIdentifier") : "EMCITY";
  }

  ngOnInit() {
    this.SliderImages = [];
    this.MediaType = [];
    this.SliderMediaType = [];
    MediaTypeList.filter(items => {
      this.ImageData.ShowItems.split('').filter(key => {
        if (key === items.DataValue) {
          this.MediaType.push(items);
        }
      });
      if (items.DataValue === "I" || items.DataValue === "V" || items.DataValue === "Y") {
        this.SliderMediaType.push(items);
      }
    });

    this.populateControls();
    this.BindPatterns();
  }

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    // if (this.ImageData.SubmitMedia) {
    //   this.SubmitToDatabase();
    // }
  }

  GetImage($event) {
    let params = new URL($event.target.src).searchParams;
    this.SMediaModel.SliderMediaID = params.get("id");
    this.SMediaModel.SliderMediaType = params.get("type");
    if (this.SMediaModel.SliderMediaType) {
      this.SMediaModel.AddNewSliderMedia = false;
    }
    switch (this.SMediaModel.SliderMediaType) {
      case "I":
        this.SMediaModel.SliderImageURL = $event.target.src;
        break;
      case "Y":
        this.SMediaModel.SliderYoutubeURL = params.get("videourl");
        break;
      case "V":
        this.SMediaModel.SliderVideoURL = $event.target.src;
        break;
    }

    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareEditHeaders2(this.SMediaModel.SliderMediaID, "SMART.MEDIA.LIBRARY.SLIDERMEDIA", this.ImageData.LGContext, this.PortalContext))
      .subscribe(data => {
        let resp: any = data.ManikJSon[0].JSon0[0];
        this.SMediaModel.SliderSavePath = resp.SavePath;
        this.MediaPropertyForm.patchValue({ "Header": resp.Header, "SubHeader": resp.SubHeader, "Description": resp.Description });
        try {
          this.ImgEdit.AppliedStyle = JSON.parse(resp.CSSStyle);
          this.SMediaModel.Transparency = this.ImgEdit.AppliedStyle.opacity ? this.ImgEdit.AppliedStyle.opacity : "1";
          this.ZIndexSelectedValue = this.ImgEdit.AppliedStyle["z-index"];//(this.ImgEdit.AppliedStyle["z-index"] !== "0" && this.ImgEdit.AppliedStyle["z-index"]) ? true : false;

          this.Overlay = (this.ImgEdit.AppliedStyle.filter) ? "Y" : "N";
        }
        catch (e) { }
      });
  }

  populateControls(): void {
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareLoadHeaders2(this.ImageData.MediaID, "SMART.MEDIA.LIBRARY", this.ImageData.LGContext, this.PortalContext))
      .subscribe(data => {
        let resp: any = data.ManikJSon[0].JSon0[0];
        this.SMediaModel.SmartMediaID = resp.SmartMediaID;
        this.SMediaModel.OpacityColor = resp.OpacityColor;
        this.SMediaModel.MediaType = resp.MediaType;
        this.SMediaModel.Height = resp.Height;
        this.SMediaModel.Width = resp.Width;
        //this.SMediaModel.Transparency = resp.Transparency;
        this.SMediaModel.RotationAngle = resp.RotationAngle;
        this.SMediaModel.ZIndex = resp.ZIndex;
        this.SMediaModel.PatternURL = resp.PatternURL;
        this.SMediaModel.SavePath = resp.SavePath;
        this.SMediaModel.SmartMediaHandle = resp.SmartMediaHandle;
        this.SMediaModel.ImageURL = resp.ImageURL;
        this.SMediaModel.VideoURL = resp.VideoURL;
        this.SMediaModel.YoutubeURL = resp.YoutubeURL;
        this.SMediaModel.IconText = resp.IconText;
        this.MediaPropertyForm.controls.Header.setValue(resp.Header);
        this.MediaPropertyForm.controls.SubHeader.setValue(resp.SubHeader);
        this.MediaPropertyForm.controls.Description.setValue(resp.Description);
        this.SMediaModel.SolidColor = resp.SolidColor;
        try {
          this.ImgEdit.AppliedStyle = {};
          resp.CSSStyle.split(',').forEach(item => {
            let d = item.split(/:(.+)/);
            this.ImgEdit.AppliedStyle[d[0]] = d[1];
          });
          this.SMediaModel.Transparency = this.ImgEdit.AppliedStyle.opacity ? this.ImgEdit.AppliedStyle.opacity : "0.7";
          if (this.ImgEdit.AppliedStyle["background-color"]) {
            this.Overlay = "Y";
            this.UseOverlay = true;
          }
        }
        catch (e) { }
        this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
          this.prepareLoadHeaders2(this.SMediaModel.SmartMediaHandle, "SMART.MEDIA.LIBRARY.SLIDERMEDIA", this.ImageData.LGContext, this.PortalContext))
          .subscribe(data => {
            let resp: any = data.ManikJSon[0].JSon0;
            this.SliderImages = [];
            resp.forEach(item => {
              switch (item.MediaType) {
                case "I":
                  this.SMediaModel.SliderImageURL = resp[0].MediaURL + "&id=" + resp[0].SliderMediaID + "&type=I";
                  this.SMediaModel.SliderSavePath = resp[0].SavePath;
                  this.SMediaModel.SliderMediaID = resp[0].SliderMediaID;
                  this.SliderImages.push(item.MediaURL + "&id=" + item.SliderMediaID + "&type=I");
                  break;
                case "Y":
                  if (item.MediaURL) {
                    var youtube_video_id = item.MediaURL.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
                    var video_thumbnail = "//img.youtube.com/vi/" + youtube_video_id + "/0.jpg";
                    this.SliderImages.push(video_thumbnail + "?id=" + item.SliderMediaID + "&type=Y&videourl=" + item.MediaURL);
                  }
                  break;
                case "V":
                  this.SliderImages.push(item.MediaURL + "&id=" + item.SliderMediaID + "&type=V");
                  break;
              }
            });
            this.SMediaModel.SliderMediaType = resp[0].MediaType;
          },
            _error => {
              // this.showNotification('bottom', 'right', 'danger', 'server error, unable to process your request.');
            });
      },
        _error => {
          // this.showNotification('bottom', 'right', 'danger', 'server error, unable to process your request.');
        });
  }

  BindPatterns() {
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("ULTRA.QUICK", "SMARTMEDIA.PATTERNS", this.ImageData.LGContext, this.PortalContext))
      .subscribe(data => {
        this.PatternList = data.ManikJSon[0].JSon0;
        this.SMediaModel.PatternURL = this.SMediaModel.PatternURL ? this.SMediaModel.PatternURL : this.PatternList[0].PatternURL;
      });
  }

  onIconPickerSelect(icon: string): void {
    this.SMediaModel.IconText = icon;
  }

  refreshDataGrid(_param: any): void {
  }

  onSliderChange(data: any | null, type: string | null): void {
    this.InitializeAllParams();
    this.ImgEdit.CommonStyle = { 'content': '', 'position': 'absolute', 'width': '100%', 'height': '100%', 'top': '0', 'left': '0', 'right': '0', 'bottom': '0' };
    switch (type) {
      case "T":
        this.ImgEdit.Opacity = { 'opacity': data.value.toString() };
        break;
      case "P":
        this.SMediaModel.ImgEditPatternURL = data;
        this.ImgEdit.Pattern = { 'z-index': '1', 'background': 'url(' + data + ') ' + this.ImgEdit.AppliedStyle["background-color"] + '', 'background-repeat': 'repeat' };
        break;
      case "O":
        if (data.value === "Y") {
          this.UseOverlay = true;
          this.ImgEdit.Overlay = { 'background-color': '' + this.SMediaModel.OpacityColor + '' };
        }
        else {
          this.UseOverlay = false;
          this.ImgEdit.Overlay = {};
          this.ImgEdit.Pattern = {};
          this.SMediaModel.ImgEditPatternURL = "";
        }
        break;
      case "C":
        this.ImgEdit.Overlay = { 'background-color': '' + this.SMediaModel.OpacityColor + '' };
        break;
      case "Z":
        this.ImgEdit.ZIndex = { 'z-index': '' + data.value + '' };
        break;
    }
    this.ImgEdit.AppliedStyle = {
      ...this.ImgEdit.Opacity,
      ...this.ImgEdit.Pattern,
      ...this.ImgEdit.Overlay,
      ...this.ImgEdit.ZIndex,
      ...this.ImgEdit.CommonStyle
    };
    this.SMediaModel.CSSStyle = JSON.stringify(this.ImgEdit.AppliedStyle).replace(/{/g, '').replace(/}/g, '').replace(/"/g, '');
  }

  InitializeAllParams() {
    this.SMediaModel.OpacityColor = (this.SMediaModel.OpacityColor) ? this.SMediaModel.OpacityColor : "#ff0000";
    this.ImgEdit.Opacity = (this.ImgEdit.Opacity) ? this.ImgEdit.Opacity : "0.7";
    if (this.ImgEdit.AppliedStyle) {
      this.ImgEdit.Opacity = { 'opacity': '' + this.ImgEdit.AppliedStyle["opacity"] + '' };
      this.ImgEdit.Pattern = { 'z-index': '1', 'background': '' + this.ImgEdit.AppliedStyle["background"] + ' ' + this.ImgEdit.AppliedStyle["background-color"] + '', 'background-repeat': 'repeat' };
      this.ImgEdit.Overlay = { 'background-color': '' + this.ImgEdit.AppliedStyle["background-color"] + '' };
      this.ImgEdit.ZIndex = { 'z-index': '' + this.ImgEdit.AppliedStyle["z-index"] + '' };
    }
  }

  SubmitToDatabase(): void {
    if (this.SMediaModel.MediaType === 'S' || this.SMediaModel.MediaType === 'F') {
      if (this.SMediaModel.SliderMediaType === 'Y' && !this.SMediaModel.SliderYoutubeURL) {
        this.showNotification('bottom', 'right', 'info', "enter youtube video url to proceed.");
        return;
      }
      else if (!this.SMediaModel.SliderMediaID && !this.ManikUploadedFile1 && this.SMediaModel.SliderMediaType !== 'Y') {
        this.showNotification('bottom', 'right', 'info', "no file choosen");
        return;
      }
    }
    else if (this.SMediaModel.MediaType === 'V' && !this.SMediaModel.VideoURL && !this.ManikUploadedFile1) {
      this.showNotification('bottom', 'right', 'info', "no file choosen");
      return;
    }
    else if (this.SMediaModel.MediaType === 'I' && !this.SMediaModel.ImageURL && !this.ManikUploadedFile1) {
      this.showNotification('bottom', 'right', 'info', "no file choosen");
      return;
    }
    else if (this.SMediaModel.MediaType === 'Y' && !this.SMediaModel.YoutubeURL) {
      this.showNotification('bottom', 'right', 'info', "enter youtube video url to proceed.");
      return;
    }
    this.FormSubmitted = true;
    let body = {};
    body = this.PrepareBody();

    let FormSubmittedData = JSON.stringify({ 'items': [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FormSubmittedData,
      this.prepareManageHeaders2("E", "SMART.MEDIA.LIBRARY", this.ImageData.LGContext, this.PortalContext))
      .subscribe(async data => {
        let id = data.ManikJSon[0].JSon0[0];
        let fileName: string = data.ManikJSon[0].JSon0[0].FileName;
        let path: string = this.SMediaModel.SavePath;

        if (this.SMediaModel.MediaType === "S" || this.SMediaModel.MediaType === "F") {
          let SliderBody = {};
          SliderBody = this.PrepareBody('Slider');
          let operationMode: string = (this.SMediaModel.SliderMediaID) ? "E" : "A";
          this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", JSON.stringify({ 'items': [SliderBody] }),
            this.prepareManageHeaders2(operationMode, "SMART.MEDIA.LIBRARY.SLIDERMEDIA", this.ImageData.LGContext, this.PortalContext))
            .subscribe(async data => {
              let id = data.ManikJSon[0].JSon0[0];
              let path: string = (operationMode === "E") ? this.SMediaModel.SliderSavePath : data.ManikJSon[0].JSon0[0].SavePath;
              let fileName: string = data.ManikJSon[0].JSon0[0].FileName;
              if (this.ManikUploadedFile1) {
                if (this.SMediaModel.SliderMediaType === "I") {
                  this._manikEntityService.manikImageUpload(this.ManikUploadedFile1,
                    this.prepareImageUploadHeader(path, fileName + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]), "", "", "user_data"))
                    .subscribe(_success => this.ngOnInit());
                }
                else {
                  this._manikEntityService.manikDocUpload(this.ManikUploadedFile1,
                    this.prepareDocUploadHeader(path, fileName + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0])))
                    .subscribe(_success => this.ngOnInit());
                }
              }
              else {
                this.ngOnInit();
              }
              this.FormSubmitted = false;
              // if (!this.ImageData.ShowSubmitButton && this.ImageData.SubmitMedia) {
              //   this.OnSuccess.emit(true);
              // }
              this.showNotification('bottom', 'right', 'success', 'request completeted successfully !!!');
            },
              error => {
                this.showNotification('bottom', 'right', 'danger', error.error.message);
                this.FormSubmitted = false;
              });
        }
        else {
          if (this.ManikUploadedFile1) {
            if (this.SMediaModel.MediaType === "I") {
              this._manikEntityService.manikImageUpload(this.ManikUploadedFile1,
                this.prepareImageUploadHeader(path, fileName + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]), "", "", "user_data"))
                .subscribe(_success => this.ngOnInit());
            }
            else {
              this._manikEntityService.manikDocUpload(this.ManikUploadedFile1,
                this.prepareDocUploadHeader(path, fileName + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0])))
                .subscribe(_success => this.ngOnInit());
            }
          }
          else {
            this.ngOnInit();
          }
          this.FormSubmitted = false;
          this.showNotification('bottom', 'right', 'success', 'request completeted successfully !!!');
        }
      }, _error => this.FormSubmitted = false);
  }

  DeleteSliderMedia(SliderMediaID: string): void {
    if (confirm("Do you really want to delete this?")) {
      let body = {};
      body["SliderMediaID"] = SliderMediaID;
      let FormSubmittedData = JSON.stringify({ 'items': [body] });
      this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FormSubmittedData,
        this.prepareManageHeaders2("D", "SMART.MEDIA.LIBRARY.SLIDERMEDIA", this.ImageData.LGContext, this.PortalContext))
        .subscribe(async data => {
          let id = data.ManikJSon[0].JSon0[0];
          this.ngOnInit();
          this.showNotification('bottom', 'right', 'warning', 'media deteted successfully !!!');
        });
    }
  }

  PrepareBody(type: string = ""): any {
    let body = this.MediaPropertyForm.value;
    body["SmartMediaHandle"] = this.SMediaModel.SmartMediaHandle;
    body["SmartMediaID"] = this.SMediaModel.SmartMediaID;
    if ((this.SMediaModel.MediaType === "S" || this.SMediaModel.MediaType === "F") && type === "Slider") {
      body["SliderMediaID"] = this.SMediaModel.SliderMediaID;
      body["MediaType"] = this.SMediaModel.SliderMediaType;

      switch (this.SMediaModel.SliderMediaType) {
        case "I":
          if (this.ManikUploadedFile1) {
            body["MediaExtension"] = this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]).toLowerCase();
          }

          if (this.SMediaModel.SliderMediaID) {
            body["SavePath"] = this.SMediaModel.SliderSavePath;
          }
          break;
        case "V":
          if (this.ManikUploadedFile1) {
            body["MediaExtension"] = this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]).toLowerCase();
          }

          body["SavePath"] = this.SMediaModel.SliderSavePath;
          break;
        case "Y":
          body["YoutubeURL"] = this.SMediaModel.SliderYoutubeURL;
          break;
        // case "O":
        //   body["SolidColor"] = this.SMediaModel.SliderSolidColor;
        //   break;
      }

      body["DisplayURL"] = "";
      body["DisplayOrder"] = "";
      body["ShowActionButton"] = "";
      body["ActionText"] = "";
      body["ActionURL"] = "";
    }
    else {
      body["MediaType"] = this.SMediaModel.MediaType;
    }

    if (type !== "Slider") {
      switch (this.SMediaModel.MediaType) {
        case "I":
          if (this.ManikUploadedFile1) {
            body["MediaExtension"] = this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]).toLowerCase();
          }
          body["SavePath"] = this.SMediaModel.SavePath;
          break;
        case "C":
          body["IconText"] = this.SMediaModel.IconText;
          break;
        case "V":
          if (this.ManikUploadedFile1) {
            body["MediaExtension"] = this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]).toLowerCase();
          }
          body["SavePath"] = this.SMediaModel.SavePath;
          break;
        case "Y":
          body["YoutubeURL"] = this.SMediaModel.YoutubeURL;
          break;
        case "O":
          body["SolidColor"] = this.SMediaModel.SolidColor;
          break;
      }
    }

    if (this.SMediaModel.MediaType === 'P') {
      body["PatternURL"] = this.SMediaModel.PatternURL;
    }
    body["Height"] = this.SMediaModel.Height;
    body["Width"] = this.SMediaModel.Width;
    body["Transparency"] = this.SMediaModel.Transparency ? this.SMediaModel.Transparency.toString() : "1";
    body["OpacityColor"] = this.SMediaModel.OpacityColor;
    body["RotationAngle"] = this.SMediaModel.RotationAngle;
    body["ZIndex"] = this.SMediaModel.ZIndex;
    body["CSSStyle"] = this.SMediaModel.CSSStyle; //this.ImgEdit.AppliedStyle;

    return body;
  }

  AddNewSliderMedia(): void {
    this.SMediaModel.AddNewSliderMedia = true;
    this.SMediaModel.SliderMediaType = "I";
    this.SMediaModel.SliderMediaID = "";
    this.SMediaModel.SliderVideoURL = "";
    this.SMediaModel.SliderImageURL = "";
    this.SMediaModel.SliderYoutubeURL = "";
    this.MediaPropertyForm.patchValue({ "Header": "", "SubHeader": "", "Description": "" });
    this.Settings = false;
    this.EditProperties = false;
    $("#file-input2").click();
  }

  GenerateEmbedYoutubeURL(type: string = "") {
    if (type === "S") {
      this.SMediaModel.SliderYoutubeURL = this.SMediaModel.SliderYoutubeURL.replace('watch?v=', 'embed/') + "?rel=0&autoplay=1&loop=1";
      var youtube_video_id = this.SMediaModel.SliderYoutubeURL.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
      var video_thumbnail = "//img.youtube.com/vi/" + youtube_video_id + "/0.jpg";
    }
    else {
      this.SMediaModel.YoutubeURL = this.SMediaModel.YoutubeURL.replace('watch?v=', 'embed/') + "?rel=0&autoplay=1&loop=1";
      var youtube_video_id = this.SMediaModel.SliderYoutubeURL.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
      var video_thumbnail = "//img.youtube.com/vi/" + youtube_video_id + "/0.jpg";
    }
  }

  OnMediaTypeChange(MediaTypeID: string) {
    this.SMediaModel.MediaType = MediaTypeID;
    this.Settings = false;
    this.EditProperties = false;
  }
}

@Pipe({ name: 'Youtube' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    url = url.replace('watch?v=', 'embed/');
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

export class SmartMediaModel {
  SmartMediaID: number = 0;;
  MediaType: string = "";
  ImageURL: string = "";
  Height: string = "";
  Width: string = "";
  Transparency: string = "";
  OpacityColor: string = "";
  Header: string = "";
  SubHeader: string = "";
  Description: string = "";
  IconText: string = "";
  YoutubeURL: string = "";
  SolidColor: string = "";
  SliderMediaType: string = "";
  RotationAngle: number = 0;
  ZIndex: number = 0;
  PatternURL: string = "";
  ImgEditPatternURL: string = "";
  SavePath: string = "";
  SmartMediaHandle: string = "";
  VideoURL: string = "";
  AddNewSliderMedia: boolean = false;
  SliderImageURL: string = "";
  SliderSavePath: string = "";
  SliderMediaID: string = "";
  SliderVideoURL: string = "";
  SliderYoutubeURL: string = "";
  CSSStyle: string = "";
}

export class EditImageStyle {
  public Opacity: any = {};
  public Pattern: any = {};
  public Overlay: any = {};
  public ZIndex: any = {};
  public CommonStyle: any = {};
  public AppliedStyle: any = {};
}
